import ContainerProps from "!!extract-react-types-loader!../../../../../../packages/design-system/badge/src/components/ContainerProps";
import * as React from 'react';
export default {
  ContainerProps,
  React
};